import styled from 'styled-components';

interface DroplistWrapperProps {
  show?: boolean;
}

export const DroplistWrapper = styled.div<DroplistWrapperProps>`
  z-index: var(--over-content-z);
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;

  > div {
    display: block;
    width: 280px;
    max-height: 208px;
    overflow: auto;
    background: white !important;
    padding: 15px;
  }

  button {
    justify-content: space-between;
    width: 100%;
    padding: 1px 6px;

    > div:first-of-type {
      padding-left: 0 !important;

      svg {
        width: 24px;
        height: 24px;
      }
    }

    > div:nth-of-type(2) {
      margin-left: 0;
    }
  }

  @media (min-width: 766px) {
    top: 40px;
    left: auto;
    right: 0;
    background-color: transparent;
    width: fit-content;
    height: auto;
    position: absolute;
  }
`;
